import { Nullable } from 'global';
import { SvgIconComponent } from '@mui/icons-material';
import {
  CreditSubmission,
  Document,
  FinanceProgram,
  Proposal,
  Reference,
  Task,
  VendorOpportunity,
  CreditApplication,
} from '@trnsact/trnsact-shared-types';

export enum InsuranceSteps {
  DetermineLenderRequirements = 'Determine Lender Requirements',
  AgentInformationNeeded = 'Agent Information Needed',
  VerifyCoverage = 'Verify Coverage',
  ShareCOI = 'Share COI',
}

export interface InsuranceStepConfiguration {
  label: string;
  icon: SvgIconComponent;
  active: boolean;
  completed: boolean;
}

export interface InsuranceAccordionConfiguration {
  header: string;
  detailsComponent: React.FC<{}>;
  disabled: boolean;
  expanded: boolean;
}

export interface InsuranceSelectSubmissionForm {
  submissionId: string;
  financeProgramId: string;
  coverageRequirements: string;
  certificateRequirements: string;
  otherInstructions: string;
}

export interface InsuranceBrokerForm {
  companyName: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  contactFax: string;
  renewalDate: Date;
  physicalDamageDeduction: number;
  liabilityCoverage: number;
  productType: string;
}

export interface InsuranceState {
  vendorOpportunity: Nullable<VendorOpportunity>;
  creditApplication: Nullable<CreditApplication>;
  submissions: CreditSubmission[];
  isInsuranceExpressIntegrated: Nullable<boolean>;
  proposals: Proposal[];
  financePrograms: FinanceProgram[];

  selectedSubmission: Nullable<CreditSubmission>;
  selectedFinanceProgram: Nullable<FinanceProgram>;

  insuranceBroker: Nullable<Reference>;
  insuranceVerificationTask: Nullable<Task>;
  insuranceCertificate: Nullable<Document>;

  stepperConfig: InsuranceStepConfiguration[];
  accordionConfig: InsuranceAccordionConfiguration[];
  coverageStatusConfig: CoverageStatusConfig;
}

export enum CoverageStatusLabels {
  Unknown = 'Unknown',
  InsuredUnverified = 'Insured, Unverified',
  InsuredVerified = 'Insured, Verified',
}

export interface CoverageStatusConfig {
  icon: SvgIconComponent;
  color: string;
  bgColor: string;
  label: CoverageStatusLabels;
  helperText?: string;
}
